import React, { useState, useEffect } from "react";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import DetailPromo from "../../components/Promo/DetailPromo";
import PromoBanner from "../../components/Promo/PromoBanner";
import PromoSlider from "../../components/Promo/PromoSlider";
import { PromoPenawaranBreadcrumb } from "../../data/DataBreadcrumb";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import UseWindowSize from "../../components/UseWindowSize";
import { scrollDetector } from "../../utils/scroll-detector";
import { SocialMediaShareBar } from "../../components/SocialMedia/SocialMediaShareBar";
import { DetailSlugContentRewardsPromoValidator } from "../../components/global/DetailContent";

const promo = ({ datas }) => {
  const { asPath, data, itemsForBreadCrumb, breadcrumb, relatedPromos, query } =
    datas;
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  useEffect(() => {
    setWinSize(width);
    scrollDetector("sticky-share-socmend", "socmed-share-wrapper");
  }, []);

  return (
    <Layout>
      <NextHead
        title={data && data.title}
        description={data && data.meta_desc}
        url={asPath}
        breadcrumb={breadcrumb}
        imgContent={data && data.banner}
        tracker={query || ""}
      />
      <PromoBanner img={data && data.banner} alt={data && data.title} />
      <DetailPromo
        startdate={data && data.start_date}
        enddate={data && data.end_date}
        title={data && data.title}
        description={data && data.description}
        breadcrumb={itemsForBreadCrumb}
        promo_url_cta={data && data.promo_url_cta}
        promo_url_cta_mobile={data && data.promo_url_cta_mobile}
        promo_text_button_cta={data && data.promo_text_button_cta}
        promo_text_button_cta_mobile={data && data.promo_text_button_cta_mobile}
      />

      <PromoSlider
        promos={relatedPromos.data}
        titledetailpromo={data && data.title}
      />
      {winSize > 600 && (
        <LayoutCenter
          id="sticky-share-socmend"
          style={{ display: "none" }}
          margin="0"
          position="sticky"
          bottom="0"
          backgroundColor="white"
          width="100%"
          widthLayout="100%"
          boxShadow={true}
          index="0"
        >
          <LayoutCenter margin="0" justifyDesktop="flex-end">
            <p>Bagikan</p>
            <SocialMediaShareBar WidthAuto title={data.title} />
          </LayoutCenter>
        </LayoutCenter>
      )}
    </Layout>
  );
};

promo.getInitialProps = async ({ res, query, asPath }) => {
  const { slug } = await query;

  return DetailSlugContentRewardsPromoValidator(
    slug,
    res,
    asPath,
    PromoPenawaranBreadcrumb,
    query,
    "Rewards",
    "promo-dan-penawaran",
    "promo-detail",
    "promo-list"
  );
};
export default promo;
